<p-toast key="myKey1"></p-toast>
<p-toast key="myKey2"></p-toast>

<app-data-table [title]="title" [columns]="tableColumns" [filters]="tableFilters" [items]="items" [totalCount]="count"
    [page]="page" [pageSize]="pageSize" [loading]="loading" [filterValues]="tableFilterValues" [deletable]="false"
    [rowActions]="rowActions" (pageChange)="handlePageChange($event)" (search)="onTableSearch($event)">
</app-data-table>

{{ error }}